import { useReducer, useEffect } from 'react';
import { useChatContext } from 'stream-chat-react';
import { StreamEventType } from '../../constants';

type ChannelEvent = {
  cid: string;
};

export function useChannelPreviewRefresh(cid: string) {
  const { client } = useChatContext();
  const [tick, forceRerender] = useReducer((c: number) => c + 1, 0);

  useEffect(() => {
    const handler = (evt: unknown) => {
      if ((evt as ChannelEvent).cid === cid) {
        forceRerender();
      }
    };

    client.on(StreamEventType.MESSAGE_NEW, handler);
    client.on(StreamEventType.NOTIFICATION_MARK_READ, handler);

    return () => {
      client.off(StreamEventType.MESSAGE_NEW, handler);
      client.off(StreamEventType.NOTIFICATION_MARK_READ, handler);
    };
  }, [client, cid]);

  return tick;
}
